var _rect, _rect2, _rect3, _path, _path2, _path3, _g, _ellipse, _path4, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path10, _path11, _path12, _path13, _path14, _rect4, _rect5, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeliciaHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 516,
    height: 463,
    viewBox: "0 0 516 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 516,
    height: 463,
    fill: "#EBEAF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7721,
    y: -2347,
    width: 10657,
    height: 5779,
    fill: "#EFF0F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    transform: "translate(-812 -193)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.279 320.359C320.819 294.332 198.356 166.576 393.291 157.144C503.335 143.31 534.499 431 503.999 443.256C421.203 451.641 307.234 426.531 288.998 421.5C266.203 415.212 225.303 340.764 267.279 320.359Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M380.272 363.084L367.695 330.071L407.783 301.774L424.29 349.722C424.29 349.722 424.29 363.084 405.87 368.586C387.451 374.089 380.272 363.084 380.272 363.084Z",
    fill: "#F6DCDC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1683_12247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 367,
    y: 301,
    width: 58,
    height: 68
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.268 363.085L367.691 330.071L407.779 301.774L424.286 349.722C413.288 370.545 403.538 373.161 380.268 363.085Z",
    fill: "#F6DCDC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1683_12247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.094 337.53L422.036 300.176L429.445 309.635C429.445 309.635 410.891 329.916 396.432 336.36C382.372 342.626 354.772 338.718 354.772 338.718L351.094 337.53Z",
    fill: "black"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 365.305,
    cy: 252.255,
    rx: 80.9613,
    ry: 80.9611,
    fill: "#F7DCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M434.508 288.411C382.315 293.442 355.133 212.285 350.941 180.32C344.653 154.818 394.518 139.797 442.467 173.597C473.042 195.151 486.7 283.38 434.508 288.411Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.57206
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M393.076 260.215C376.83 251.535 355.096 252.374 346.913 273.705C354.861 280.628 375.22 287.623 393.076 260.215Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1683_12247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 255,
    width: 48,
    height: 25
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.08 260.212C376.834 251.532 355.1 252.372 346.917 273.702C354.865 280.626 375.224 287.62 393.08 260.212Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1683_12247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6034,
    cy: 16.603,
    rx: 16.6034,
    ry: 16.603,
    transform: "matrix(0.995267 -0.0971772 0.0971821 0.995267 349.48 243.863)",
    fill: "#1B1B1B"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M283.582 241.972C301.834 239.491 321.915 247.845 322.16 270.69C312.299 274.413 290.778 273.881 283.582 241.972Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1683_12247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 283,
    y: 241,
    width: 40,
    height: 32
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M283.578 241.968C301.83 239.488 321.912 247.842 322.156 270.687C312.295 274.41 290.774 273.878 283.578 241.968Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1683_12247)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.6034,
    cy: 16.6031,
    rx: 16.6034,
    ry: 16.6031,
    transform: "matrix(-0.899163 -0.437613 -0.437632 0.899154 334.695 242.722)",
    fill: "#1B1B1B"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M295.381 182.297C313.814 157.455 348.831 158.192 366.91 163.432C350.405 163.432 307.512 210.755 295.382 255.646C286.739 287.633 270.002 216.5 295.381 182.297Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.57206
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M350.402 241.249C358.263 238.891 377.599 236.847 392.062 247.537",
    stroke: "black",
    strokeWidth: 3.14412,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318.959 237.319C315.815 234.437 306.069 228.83 292.234 229.458",
    stroke: "black",
    strokeWidth: 3.14412,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.919 302.092L319.821 297.196C317.509 298.06 319.417 299.462 320.175 300.899C321.725 303.835 323.405 307.015 327.828 309.448C332.128 303.979 345.916 305.179 352.272 306.462C352.789 304.924 352.93 303.362 352.919 302.092Z",
    fill: "#FDF5F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M336.138 312.276C346.905 314.426 350.904 310.53 352.272 306.462C345.916 305.179 332.128 303.979 327.828 309.448C329.904 310.589 332.584 311.566 336.138 312.276Z",
    fill: "#EF9595"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M327.85 268.952L314.127 280.51L323.375 286.678",
    stroke: "#EEC5C5",
    strokeWidth: 1.57206,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.187655,
    y: 1.09566,
    width: 51.7003,
    height: 106.473,
    rx: 3.93015,
    transform: "matrix(0.816328 0.577588 -0.57759 0.816327 419.609 242.127)",
    fill: "#FFF0F0",
    stroke: "black",
    strokeWidth: 1.57206
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.187655,
    y: 1.09566,
    width: 51.7003,
    height: 106.473,
    rx: 3.93015,
    transform: "matrix(0.816328 0.577588 -0.57759 0.816327 424.324 245.271)",
    fill: "url(#paint0_linear_1683_12247)",
    stroke: "black",
    strokeWidth: 1.57206
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M444.521 318.526L431.99 338.716V369.886C431.99 373.684 429.273 376.94 425.535 377.619L398.024 382.621C393.199 383.498 388.758 379.792 388.758 374.888V333.827C388.758 333.419 388.79 333.012 388.853 332.609L394.528 296.428C394.826 294.527 396.464 293.127 398.387 293.127C400.476 293.127 402.195 294.769 402.29 296.856L403.605 325.793C403.654 326.867 404.538 327.712 405.613 327.712C406.723 327.712 407.623 326.812 407.623 325.702V279.764C407.623 276.725 410.086 274.262 413.125 274.262C416.164 274.262 418.627 276.725 418.627 279.764V326.14C418.627 327.008 419.331 327.712 420.199 327.712C421.067 327.712 421.771 327.008 421.771 326.14V276.227C421.771 273.405 424.059 271.118 426.88 271.118C429.702 271.118 431.99 273.405 431.99 276.227V313.956C431.99 315.042 432.869 315.921 433.955 315.921C435.04 315.921 435.92 315.042 435.92 313.956V284.087C435.92 281.265 438.207 278.978 441.029 278.978C443.851 278.978 446.138 281.265 446.138 284.087V304.09C446.138 305.154 445.922 306.208 445.503 307.186L444.791 308.847L445.565 312.91C445.933 314.847 445.561 316.851 444.521 318.526Z",
    fill: "#F6DCDC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M431.99 338.716L444.521 318.526C445.561 316.851 445.933 314.847 445.565 312.91L444.791 308.847M431.99 338.716V369.886C431.99 373.684 429.273 376.94 425.535 377.619L398.024 382.621C393.199 383.498 388.758 379.792 388.758 374.888V333.827C388.758 333.419 388.79 333.012 388.853 332.609L394.528 296.428C394.826 294.527 396.464 293.127 398.387 293.127V293.127C400.476 293.127 402.195 294.769 402.29 296.856L403.605 325.793C403.654 326.867 404.538 327.712 405.613 327.712V327.712C406.723 327.712 407.623 326.812 407.623 325.702V279.764C407.623 276.725 410.086 274.262 413.125 274.262V274.262C416.164 274.262 418.627 276.725 418.627 279.764V326.14C418.627 327.008 419.331 327.712 420.199 327.712V327.712C421.067 327.712 421.771 327.008 421.771 326.14V276.227C421.771 273.405 424.059 271.118 426.88 271.118V271.118C429.702 271.118 431.99 273.405 431.99 276.227V313.956C431.99 315.042 432.869 315.921 433.955 315.921V315.921C435.04 315.921 435.92 315.042 435.92 313.956V284.087C435.92 281.265 438.207 278.978 441.029 278.978V278.978C443.851 278.978 446.138 281.265 446.138 284.087V304.09C446.138 305.154 445.922 306.208 445.503 307.186L444.791 308.847M431.99 338.716L444.791 308.847",
    stroke: "black",
    strokeWidth: 1.57206
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7513 186.085L16.6998 27.7426C16.3974 25.6655 18.4794 24.0546 20.4141 24.8688L182.387 93.0318C185.87 94.4977 188.332 97.6797 188.877 101.419L213.203 268.521C213.513 270.652 211.323 272.269 209.378 271.345L192.054 263.116C191.081 262.654 189.986 263.463 190.141 264.528L195.411 300.725C195.619 302.152 193.743 302.865 192.95 301.66L159.688 251.088C159.019 250.071 158.087 249.254 156.991 248.724L46.4747 195.26C42.8501 193.507 40.3313 190.07 39.7513 186.085Z",
    fill: "#FFC5C5",
    stroke: "black",
    strokeWidth: 1.34824,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3216 192.419L1.27011 34.0761C0.967733 31.999 3.04975 30.3881 4.98437 31.2022L166.957 99.3653C170.44 100.831 172.902 104.013 173.447 107.753L197.773 274.854C198.084 276.985 195.893 278.602 193.948 277.678L176.624 269.45C175.652 268.988 174.556 269.796 174.712 270.862L179.981 307.058C180.189 308.485 178.313 309.198 177.52 307.993L144.258 257.421C143.589 256.404 142.657 255.587 141.562 255.057L31.045 201.594C27.4204 199.841 24.9016 196.403 24.3216 192.419Z",
    fill: "url(#paint1_linear_1683_12247)",
    stroke: "black",
    strokeWidth: 1.34824,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.304 24.7263L3.54362 30.9625",
    stroke: "black",
    strokeWidth: 1.34824,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.205 271.033L196.778 277.366",
    stroke: "black",
    strokeWidth: 1.34824,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.272 302.255L178.844 308.588",
    stroke: "black",
    strokeWidth: 1.34824,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.738 171.543C156.626 176.284 157.974 181.311 157.85 185.586C157.726 189.869 156.135 193.304 153.253 195.059C150.371 196.814 146.589 196.651 142.727 194.796C138.872 192.945 135.025 189.44 132.137 184.699C129.249 179.957 127.9 174.93 128.025 170.655C128.149 166.373 129.739 162.938 132.621 161.182C135.503 159.427 139.285 159.59 143.147 161.445C147.003 163.296 150.85 166.801 153.738 171.543Z",
    fill: "#FFC5C5",
    stroke: "black",
    strokeWidth: 1.34824
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M109.632 150.15C112.52 154.892 113.869 159.919 113.745 164.194C113.62 168.476 112.03 171.911 109.148 173.666C106.266 175.422 102.484 175.259 98.6218 173.404C94.7666 171.553 90.919 168.047 88.0313 163.306C85.1436 158.564 83.795 153.537 83.9191 149.263C84.0434 144.98 85.634 141.545 88.516 139.79C91.398 138.035 95.1798 138.198 99.0419 140.052C102.897 141.904 106.745 145.409 109.632 150.15Z",
    fill: "#FFC5C5",
    stroke: "black",
    strokeWidth: 1.34824
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5269 128.759C68.4147 133.5 69.7633 138.527 69.6392 142.802C69.5148 147.085 67.9243 150.52 65.0423 152.275C62.1603 154.03 58.3785 153.867 54.5163 152.012C50.6611 150.161 46.8136 146.656 43.9259 141.914C41.0381 137.173 39.6895 132.146 39.8136 127.871C39.938 123.588 41.5285 120.153 44.4105 118.398C47.2925 116.643 51.0743 116.806 54.9365 118.661C58.7917 120.512 62.6392 124.017 65.5269 128.759Z",
    fill: "#FFC5C5",
    stroke: "black",
    strokeWidth: 1.34824
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 387.375L181.303 443.748L189.01 439.859C191.036 438.836 192.292 436.737 192.235 434.468L190.887 380.637L179.892 387.375Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M181.303 443.748L179.892 387.375C176.358 385.91 173.245 384.29 170.517 382.602L171.916 438.448L181.303 443.748Z",
    fill: "#FFF0F0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M179.892 387.375L190.887 380.637C188.399 379.506 184.891 377.744 181.389 375.686L170.517 382.602C173.245 384.29 176.358 385.91 179.892 387.375Z",
    fill: "#FFF0F0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.067 365.106L139.473 321.991L151.085 316.412C153.797 323.917 158.422 336.531 162.333 347.2C165.198 355.014 167.68 361.784 168.748 364.739C169.999 368.202 175.687 372.335 181.389 375.686L170.517 382.602C160.045 376.123 155.244 368.651 154.067 365.106Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.085 316.412C147.928 307.677 141.559 305.586 136.318 307.48L126.232 312.456C130.246 311.223 135.962 312.918 139.473 321.991L151.085 316.412Z",
    fill: "#FFF0F0"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.178 344.88C126.337 345.899 125.184 346.64 124.298 346.112C121.509 344.451 117.022 342.134 110.688 339.851L121.683 333.112L124.499 334.117L126.178 344.88Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.683 333.112C120.497 332.654 117.975 331.695 115.662 333.164C113.348 334.632 108.137 337.707 105.82 339.061C106.744 338.655 109.244 339.331 110.688 339.851L121.683 333.112Z",
    fill: "#FFF0F0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M154.067 365.106L139.473 321.991C135.962 312.918 130.246 311.223 126.232 312.456L123.985 313.565C122.896 314.348 122.128 315.371 121.93 317.245C121.889 317.633 121.919 318.024 121.981 318.409L124.499 334.117L126.178 344.88C126.337 345.899 125.184 346.64 124.298 346.112C121.509 344.451 117.022 342.134 110.688 339.851C109.244 339.331 106.744 338.655 105.82 339.061C99.5952 342.7 102.974 360.609 104.656 380.545C106.536 402.826 107.402 402.217 117.53 407.74L171.916 438.448L170.517 382.602C160.045 376.123 155.244 368.651 154.067 365.106Z",
    fill: "#FFC5C5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M139.473 321.991L154.067 365.106C155.244 368.651 160.045 376.123 170.517 382.602M139.473 321.991C135.962 312.918 130.246 311.223 126.232 312.456M139.473 321.991L151.085 316.412M179.892 387.375L181.303 443.748M179.892 387.375L190.887 380.637M179.892 387.375C176.358 385.91 173.245 384.29 170.517 382.602M181.303 443.748L189.01 439.859C191.036 438.836 192.292 436.737 192.235 434.468L190.887 380.637M181.303 443.748L171.916 438.448M110.688 339.851C117.022 342.134 121.509 344.451 124.298 346.112C125.184 346.64 126.337 345.899 126.178 344.88L124.499 334.117M110.688 339.851C109.244 339.331 106.744 338.655 105.82 339.061M110.688 339.851L121.683 333.112M190.887 380.637C188.399 379.506 184.891 377.744 181.389 375.686M151.085 316.412C147.928 307.677 141.559 305.586 136.318 307.48L126.232 312.456M151.085 316.412C153.797 323.917 158.422 336.531 162.333 347.2C165.198 355.014 167.68 361.784 168.748 364.739C169.999 368.202 175.687 372.335 181.389 375.686M123.985 313.565C122.896 314.348 122.128 315.371 121.93 317.245C121.889 317.633 121.919 318.024 121.981 318.409L124.499 334.117M123.985 313.565L126.232 312.456M123.985 313.565C124.637 313.095 125.397 312.713 126.232 312.456M124.499 334.117L121.683 333.112M121.683 333.112C120.497 332.654 117.975 331.695 115.662 333.164C113.348 334.632 108.137 337.707 105.82 339.061M105.82 339.061C99.5952 342.7 102.974 360.609 104.656 380.545C106.536 402.826 107.402 402.217 117.53 407.74L171.916 438.448M170.517 382.602L181.389 375.686M170.517 382.602L171.916 438.448",
    stroke: "black",
    strokeWidth: 1.17481,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M290.194 194.548L85.9769 105.559C81.2707 103.508 76.0907 107.26 76.5725 112.371L89.1428 245.731C89.3634 248.072 90.7877 250.128 92.9012 251.158L295.432 349.851C300.112 352.132 305.501 348.471 305.106 343.28L294.223 200.216C294.034 197.727 292.484 195.545 290.194 194.548Z",
    fill: "url(#paint2_linear_1683_12247)",
    fillOpacity: 0.8,
    stroke: "black",
    strokeWidth: 1.34824
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M274.356 219.449L213.984 191.832C213.001 191.383 211.915 192.214 212.093 193.28L217.053 223.046C217.125 223.479 217.404 223.85 217.8 224.04L276.873 252.406C277.832 252.867 278.922 252.086 278.795 251.03L275.133 220.514C275.077 220.048 274.783 219.644 274.356 219.449Z",
    stroke: "black",
    strokeWidth: 1.34824
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M274.356 277.934L213.984 250.317C213.001 249.867 211.915 250.699 212.093 251.765L217.053 281.531C217.125 281.964 217.404 282.334 217.8 282.525L276.873 310.891C277.832 311.351 278.922 310.571 278.795 309.515L275.133 278.999C275.077 278.533 274.783 278.129 274.356 277.934Z",
    stroke: "black",
    strokeWidth: 1.34824
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1683_12247",
    x1: 26.6362,
    y1: 0,
    x2: 26.6362,
    y2: 108.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1683_12247",
    x1: 79.6321,
    y1: 17.8416,
    x2: 123.819,
    y2: 321.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1683_12247",
    x1: 188.442,
    y1: 98.974,
    x2: 193.056,
    y2: 357.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4D5FD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeliciaHelp);
export default __webpack_public_path__ + "static/media/felicia-help.a9d89aca78a56dbd0f689e42f0be31b3.svg";
export { ForwardRef as ReactComponent };